<div class="wwd-research">
  <div class="wwd-row">
    <div class="wwd-col wwd-research__col">
      <p class="wwd-research__lead">{{ 'WHAT-WE-DO_RESEARCH-LEAD' | translate }}</p>
      <div class="wwd-list" [innerHTML]="'WHAT-WE-DO_RESEARCH-LIST' | translate"></div>
    </div>

    <img
      class="wwd-media"
      src="assets/images/what-we-do/photo-research.png"
      [alt]="'WHAT-WE-DO_RESEARCH-PHOTO-ALT' | translate"
    />
  </div>
</div>
